import createModule from "../createModule"
import view from "./view"
import { getSelectedContributorCategory, getDetails, getSelectedContributorValue } from "./selectors"
import { getSortOrder, getGroupSortOrder } from "helpers/compositeSecuritiesDetails"
import { Creators } from "./model"

import { Creators as ProfileCreators } from "model/profileModal"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    details: getDetails(state, props),
    selectedContributorCategory: getSelectedContributorCategory(state, props),
    selectedContributorValue: getSelectedContributorValue(state, props),
    sortOrder: getSortOrder(state, props),
    groupOrder: getGroupSortOrder(state, props),
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
